enum TreeNodeType {
  ENTITE = 'entite',
  BORDEREAU = 'bordereau',
  MOUVEMENT = 'mouvement',
  CREATE_MOUVEMENT = 'create-mouvement',
  CREATE_BORDEREAU = 'create-bordereau',
}

export default TreeNodeType;
